import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'btn-subscription',
	template: require('./btn-subscription.html')
})
export class BtnSubscriptionComponent {
	@Input() status: any;
	@Output() action: EventEmitter<any> = new EventEmitter();
	constructor() {
		console.log(status);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/buttons/btn-subscription/btn-subscription.ts